"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
export default function AboutUs() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}